var PageBackgroundSupport = require("app/ui/PageBackgroundSupport"),
    ImageOptimizerSupport = require("app/ui/ImageOptimizerSupport"),
    PopupLayout           = require("app/AppLayout/PopupLayout"),
    ScrollerPopup         = require("app/ui/ScrollerPopup"),
    closeButtonThemeVars  = require("app/theme/IconButtonVariables--close"),
    frameThrottle         = require("enyo-perf/utils").frameThrottle,
    get                   = require("object-path").get,
    kind                  = require("enyo/kind"),
    themeVars             = require("app/theme/variables.js");

require("./LongDescription.less");
require("app/theme/IconButton--negative.less");
require("app/theme/styles/popups/ScrollerPopup--bordered.less");

module.exports = kind(/** @lends  app.MediaPlayer.Tech.ImageViewer.LongDescription.prototype */ {

    /**
     * @private
     */
    name: "app.MediaPlayer.Tech.ImageViewer.LongDescription",

    /**
     * @private
     */
    kind: ScrollerPopup,

    /**
     * @private
     */
    mixins: [
        ImageOptimizerSupport,
        PageBackgroundSupport
    ],

    /**
     * @private
     */
    layoutKind: PopupLayout,

    /**
     * @private
     */
    layoutOptions: {
        alignment: "owner",

        /**
         * @returns {number} The margin in pixels
         */
        marginTop: function() {
            return themeVars.getContentPaddingVerticalPx()
                + (this.container.get("showCloseButton")
                    ? closeButtonThemeVars.getIconSize() / 2
                    : 0);
        },

        /**
         * @returns {number} The margin in pixels
         */
        marginBottom: function() {
            return themeVars.getContentPaddingVerticalPx();
        }
    },

    /**
     * @private
     */
    classes: "app-media-player-image-viewer-long-description",

    /**
     * @public
     */
    theme: "bordered",

    /**
     * @public
     */
    floating: false,

    /**
     * @private
     */
    captureEvents: true,

    /**
     * @private
     */
    components: [{
        name:       "description",
        classes:    "app-media-player-image-viewer-long-description__description",
        components: [{
            name:      "body",
            allowHtml: true,
            classes:   "app-media-player-image-viewer-long-description__body"
        }]
    }],

    /**
     * @private
     */
    observers: {
        update: ["state"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var state   = this.state || {},
            content = get(state, "media.meta.html_long_description", null) || "";

        this.$.body.set("content", content);
    }

});
